import React from 'react';
import { FiPhone, FiSend } from "react-icons/fi";
import { FaBars } from "react-icons/fa";
import { MdShoppingCart } from "react-icons/md";
import { AiOutlineUser } from "react-icons/ai";
 
const MyAccount = () => {
    return (
        <div className="w-100">
 
            {/* Top Info Bar */}
            <div className="py-1 bg-primary w-100">
                <div className="container">
                    <div className="row d-flex align-items-center text-white">
                        <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
                            <FiPhone size={14} className="mr-2" />
                            <span>+91 9148761750</span>
                        </div>
 
                        <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
                            <FiSend size={14} className="mr-2" />
                            <span>care@fhome.shop</span>
                        </div>
 
                        <div className="col-12 col-md text-md-right">
                            <span>3-5 Business days delivery & Free Returns</span>
                        </div>
                    </div>
                </div>
            </div>
 
            {/* Navbar */}
          <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "55px", marginRight: "8px", borderRadius: "50%", width: "80px" }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <FaBars className="mr-2" /> Menu
          </button>
 
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active"><a href="/" className="nav-link">Home</a></li>
              <li className="nav-item"><a href="/about" className="nav-link">About</a></li>
              {/* <li className="nav-item"><a href="/blog" className="nav-link">Blog</a></li> */}
              <li className="nav-item"><a href="/contact" className="nav-link">Contact</a></li>
 
              <li className="nav-item cta cta-colored"><a href="/cart" className="nav-link"><span><MdShoppingCart size={18} /></span> [0]</a></li>
             
 
 
              {/* <li className="nav-item"><a href="/admin" className="nav-link">Admin Products</a></li> */}
            </ul>
          </div>
        </div>
      </nav>
 
            {/* My Account Section */}
            <div className="container py-5">
                <h2 className="mb-4 font-weight-bold">My Account</h2>
 
                <ul className="list-group shadow-sm">
                    <a href="/my-orders" className="list-group-item list-group-item-action">
                        <AiOutlineUser className="mr-2" /> My Orders
                    </a>
 
                    <a href="/wishlist" className="list-group-item list-group-item-action">
                        ❤️ Wishlist
                    </a>
 
                    <a href="/settings" className="list-group-item list-group-item-action">
                        ⚙️ Settings
                    </a>
                </ul>
            </div>
        </div>
    );
};
 
export default MyAccount;
 
 
